export const LocationTypes = Object.freeze({
  FILLED: "FILLED_LOCATIONS",
  EMPTY: "EMPTY_LOCATIONS",
  ALL: "ALL_LOCATIONS",
});

export const MAX_CAPACITY_OPTIONS = Array.from({ length: 10 }, (_, i) => ({
    label: `${i + 1}`,
    value: i + 1,
    key: i + 1,
}));